import { getInitData } from "./telegram";

// Пустой BASE_URL = относительный путь — будет проксироваться через vite на :8080
// (см. vite.config.ts → server.proxy). В проде BASE_URL подставится из .env через VITE_BACKEND_URL.
const BASE_URL = import.meta.env.VITE_BACKEND_URL ?? "";

export interface SubmitResult {
  ok: boolean;
  id?: string;
  error?: string;
  details?: any;
}

export async function submitApplication(type: string, payload: object): Promise<SubmitResult> {
  try {
    const res = await fetch(`${BASE_URL}/api/applications/${type.toLowerCase()}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        initData: getInitData(),
        payload,
      }),
    });
    const data = await res.json();
    if (!res.ok) {
      return { ok: false, error: data.error ?? "Request failed", details: data.details };
    }
    return { ok: true, id: data.id };
  } catch (err) {
    return { ok: false, error: err instanceof Error ? err.message : String(err) };
  }
}
